import {RequestOptionsArgs, RequestMethod, RequestOptions, BaseRequestOptions, URLSearchParams} from "@angular/http";
import {PaginationPropertySort} from "./pagination.property.sort";
import {PropertyFilter} from "./property-filter";
/**
 * Created by Lauta on 10/2/2017.
 */

export class QueryOptions {
    page = 0;
    size = 10;
    sorts: PaginationPropertySort[] = [];
    private _andFilters: Array<PropertyFilter> = [];
    private _orFilters: Array<PropertyFilter> = [];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }

    merge(values: Object = {}): QueryOptions {
        return Object.assign(this, values);
    }

    public getQueryRequestOptions(): BaseRequestOptions {
        const reqOptions = new BaseRequestOptions();
        reqOptions.method = RequestMethod.Get;

        reqOptions.params = new URLSearchParams();

        reqOptions.params.set('size', `${this.size}`);

        reqOptions.params.set('page', `${this.page}`);

        if (this.sorts != null) {
            this.sorts.forEach(sort => reqOptions.params.append('sort', `${sort.property},${sort.direction}`))
        }
        return reqOptions;
    }


    get andFilters(): Array<PropertyFilter> {
        return this._andFilters;
    }

    set andFilters(value: Array<PropertyFilter>) {
        this._andFilters = value.map(f => new PropertyFilter(f));
    }


    get orFilters(): Array<PropertyFilter> {
        return this._orFilters;
    }

    set orFilters(value: Array<PropertyFilter>) {
        this._orFilters = value.map(f => new PropertyFilter(f));
    }
}




// WEBPACK FOOTER //
// ./src/app/core/commons/query.options.ts